import React, {useMemo} from "react";
import {Formik} from "formik";
import {isEqual} from "lodash";
import {useUserUIContext} from "../UserUIContext";
import {initialFilter, role} from "../UserUIHelpers"

const prepareFilter = (queryParams, values) => {
    const {name, email, role} = values;
    const newQueryParams = {...queryParams};
    const filter = {};

    //add to Object filter
    filter.name = name;
    filter.email = email;
    filter.role = role;

    newQueryParams.filter = filter;
    return newQueryParams;
};

export function UserFilter({listLoading}) {
    // User UI Context
    const userUIContext = useUserUIContext();
    const userUIProps = useMemo(() => {
        return {
            setQueryParams: userUIContext.setQueryParams,
            queryParams: userUIContext.queryParams,
        };
    }, [userUIContext]);

    const applyFilter = (values) => {
        const newQueryParams = prepareFilter(userUIProps.queryParams, values);
        if (!isEqual(newQueryParams, userUIProps.queryParams)) {
            newQueryParams.pageNumber = 1;
            userUIProps.setQueryParams(newQueryParams);
        }
    };

    return (
        <Formik initialValues={initialFilter.filter} onSubmit={(values) => {
            applyFilter(values);
        }}
        >{({values, handleSubmit, handleBlur, setFieldValue}) => (
            <form onSubmit={handleSubmit} className="form form-label-right">
                <div className="form-group row">
                    <div className="col">
                        <input
                            type="text"
                            className="form-control"
                            name="name"
                            placeholder="fulan"
                            onBlur={handleBlur}
                            value={values.name}
                            onChange={(e) => {
                                setFieldValue("name", e.target.value);
                                handleSubmit();
                            }}
                        />
                        <small className="form-text text-muted">
                            <b>Cari</b> Berdasarkan Nama
                        </small>
                    </div>
                    <div className="col">
                        <input
                            type="text"
                            className="form-control"
                            name="email"
                            placeholder="fulan@fulan.com"
                            onBlur={handleBlur}
                            value={values.email}
                            onChange={(e) => {
                                setFieldValue("email", e.target.value);
                                handleSubmit();
                            }}
                        />
                        <small className="form-text text-muted">
                            <b>Cari</b> Berdasarkan Email
                        </small>
                    </div>
                    <div className="col">
                        <select
                            className="form-control"
                            name="role"
                            label="Role"
                            onChange={(e) => {
                                setFieldValue("role", e.target.value);
                                handleSubmit();
                            }}
                        >
                            <option value="">-PILIH-</option>
                            {role.map(row =>
                                <option key={row.value} value={row.value}>{row.name}</option>
                            )}
                        </select>
                        <small className="form-text text-muted">
                            <b>Cari</b> Berdasarkan Role
                        </small>
                    </div>
                </div>
            </form>
        )}
        </Formik>

    )
}
